var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmaps-Map',{style:(_vm.mapStyle),attrs:{"options":_vm.mapOptions,"zoom":10},on:{"click":function($event){return _vm.addMarker(_vm.latLng, _vm.mapObj)}}},[_c('gmaps-heatmap',{attrs:{"items":_vm.getHeatmapItems(),"opacity":0.8}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }